import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { TranslationInfo } from 'redux/schemas/models/edit-translations';
import { getLectureComponent } from 'redux/selectors/timeline';
import { ComponentType, NLectureComponent } from 'redux/schemas/models/lecture-component';
import EditableQuizBase from './quiz-base/editable-quiz-base';


type EditableProps = {
  editInfo: TranslationInfo,
  containerClass: string,
  onSaveRef: (fn: () => void) => void,
  setSavingDisabled: (boolean) => void,
};

const EditableSurvey = ({
  editInfo,
  containerClass,
  onSaveRef,
  setSavingDisabled,
}: EditableProps) => {
  const lectureComponent = useSelector((state) => (
    getLectureComponent(state, editInfo.id)
  )) as NLectureComponent<ComponentType.SURVEY>;
  const currentSurvey = useSelector((state) => state.models.surveys[lectureComponent.survey]);
  const currentQuestions = useMemo(() => (
    currentSurvey.questions?.map((surveyQuestion) => {
      const { id, questionText, type, numRows, numColumns, translationIds: qTranslationIds } = surveyQuestion;
      const currentQuestion = {
        question: {
          id,
          questionText,
          type,
          numRows,
          numColumns,
          translationIds: qTranslationIds,
        },
        options: surveyQuestion.responseOptions?.map((currentOption) => {
          const { id: optionId, optionContent, readOnly, translationIds: oTranslationIds } = currentOption;
          return {
            id: optionId,
            optionContent,
            readOnly,
            translationIds: oTranslationIds,
          };
        }),
      };
      return currentQuestion;
    })
  ), [currentSurvey]);

  return (
    <EditableQuizBase
      componentType={ComponentType.SURVEY}
      currentQuiz={currentSurvey}
      currentQuestions={currentQuestions}
      containerClass={containerClass}
      onSaveRef={onSaveRef}
      setSavingDisabled={setSavingDisabled}
      lectureComponent={lectureComponent}
      editInfo={editInfo}
    />
  );
};

export default EditableSurvey;
